import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { CountryModel, ProvinceModel } from 'src/app/shared/models/address.model';
import { ClientService } from 'src/app/shared/services/client.service';
import { CountryService } from 'src/app/shared/services/country.service';
import { ProvinceService } from 'src/app/shared/services/province.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-client-detail',
  templateUrl: './client-detail.component.html',
  styleUrls: ['./client-detail.component.css']
})
export class ClientDetailComponent implements OnInit {
  listCountry : CountryModel [];
  listProvince : ProvinceModel [];
  currentProvince : ProvinceModel [];
  country_code : string;
  province_code : string;
  dialogData :any;
  positoinList = GlobalConstants.constPositionArray;


  constructor(
    public service: ClientService,
    private countryservce : CountryService,
    private provinceservce : ProvinceService,
   // private toastr : ToastrService,
    private gnotify : GlobalNotification,
    public dialogRef: MatDialogRef<ClientDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data : any) {

      this.dialogData = data;
    }

  ngOnInit() {
    this.countryservce.getList().subscribe(
      res=>{
        this.listCountry = res as CountryModel[];
      },
      err=>{}
      );

      this.provinceservce.getList().subscribe(
        res=>{
          this.listProvince = res as ProvinceModel[];
          this.onCountryChangeAction();
        },
        err=>{}
      );

  }

  getPositionString(type)
  {
    return GlobalConstants.getPositionString(type);
  }

  onCountryChangeAction(){
    var value = this.service.form.get('countryCode').value;

    console.log("onCountryChangeAction  : "  +  value);

    if(this.listProvince != null)
    {
      this.currentProvince = this.listProvince.filter(x => x.countryCode == value);
    }
  }

  onClose() {

    this.service.form.reset();
    this.service.initializeFormGroup();
    this.dialogRef.close();
  }

  onSubmit() {
    console.log("Create Customer");
  //  var error;
  //  var result = false;
      if (!this.service.form.valid) {
        ////this.toastr.warning("Pleaes check all the medatory inputs.", "Invalid");
        this.gnotify.showSnackBar('Invalid', 'Pleaes check all the medatory inputs.', "warning");
        return;
      }

      if (!this.service.form.get('clientId').value){
        this.service.insertData(this.service.form.value).subscribe(
          res=>{
            //this.service.list.push(res as Customer);
             ////this.toastr.success("Submit successfuly", "Customer Create");
             this.gnotify.showSnackBar('Customer Create', 'Submit successfuly', "success");
             this.dialogData.result = true;
             this.dialogData.data = res;
             this.onClose();
          },
          err=>{
            console.log(err);
            //this.notificationService.warn(':: Submit failed');
            ////this.toastr.error("Failed to Submit", "Customer Create");
            this.gnotify.showSnackBar('Customer Create', 'Failed to Submit', "error");
            return;
          }
          );
      }
      else{
        this.service.updateData(this.service.form.value).subscribe(
          res=>{
            ////this.toastr.success("Submit successfuly", "Customer Modify");
            this.gnotify.showSnackBar('Customer Modify', 'Submit successfuly', "success");
            this.dialogData.result = true;
            this.dialogData.data = this.service.form.value;
            this.onClose();
          },
          err=>{
            console.log(err);
            ////this.toastr.error("Failed to Submit", "Customer Modify");
            this.gnotify.showSnackBar('Customer Modify', 'Failed to Submit', "error");
            return;
          }
          );

      }

    }

}
